<!--
    描述：项目管理
    时间：2021-03-26
    Created by 王帅
-->
<template>
	<el-tabs type="card"
			 class="full-tabs card-tabs"
			 v-model="activeTab">
		<!-- 工程审计菜单 -->
		<el-tab-pane label="工程项目"
					 name="project">
			<div class="filter-layout">
				<!-- 筛选搜索栏 -->
				<div class="filter-box">
					<el-form ref="elForm"
							 :model="searchObj"
							 size="small"
							 label-width="130px"
							 v-show="filterShow">
						<el-row>
							<el-col :span="6">
								<el-form-item label="项目名称"
											  prop="sname">
									<el-input v-model="searchObj.sname"
											  placeholder="请输入工程项目名称"
											  clearable>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="建设单位"
											  prop="unitName">
									<el-input v-model="searchObj.unitName"
											  placeholder="请输入建设单位名称（全称或简称）"
											  clearable>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="建设单位负责人"
											  prop="unitLinker">
									<el-input v-model="searchObj.unitLinker"
											  placeholder="请输入建设单位负责人"
											  clearable>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="项目类型"
											  prop="proType">
									<el-select v-model="searchObj.proType"
											   placeholder="请选择项目类型"
											   clearable>
										<el-option v-for="(item, index) in projectDict.dxxmlx"
												   :key="index"
												   :label="item.sname"
												   :value="item.value"
												   :disabled="item.disabled"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="6">
								<el-form-item label="项目归属区域"
											  prop="isNorth">
									<el-select placeholder="请选择项目归属区域"
											   v-model="searchObj.isNorth"
											   size="small">
										<el-option v-for="item in projectDict.xmgsqy"
												   :key="item.id"
												   :value="item.value"
												   :label="item.sname"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="施工单位"
											  prop="buildUnitName">
									<el-input v-model="searchObj.buildUnitName"
											  placeholder="请输入施工单位名称（全称或简称）"
											  clearable>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="建设任务书编号"
											  prop="assignNo">
									<el-input v-model="searchObj.assignNo"
											  placeholder="请输入建设任务书编号"
											  :maxlength="20"
											  clearable></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="项目造价区间"
											  prop="intervalPrice">
									<el-select v-model="searchObj.intervalPrice"
											   placeholder="请选择项目造价区间">
										<el-option v-for="(item, index) in projectDict.xmzjqj"
												   :key="'造价区间' + index"
												   :label="item.sname"
												   :value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>

						</el-row>
						<el-row>
							<el-col :span="6">
								<el-form-item label="项目年份"
											  prop="proYear">
									<el-date-picker type="year"
													v-model="searchObj.proYear"
													format="yyyy"
													value-format="yyyy"
													placeholder="请选择项目年份"
													clearable></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标签搜索"
											  prop="tagIds">
									<el-select v-model="searchObj.tagIds"
											   placeholder="请选择标签"
											   popper-class="tag-box"
											   multiple
											   :popper-append-to-body="false">
										<el-option v-for="(item, index) in tagList"
												   :key="'tagList' + index"
												   :label="item.sname"
												   :value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item size="small"
											  label-width="0"
											  class="text-right">
									<el-button class="btn-blue"
											   icon="el-icon-search"
											   @click="getTableData(1)">查询</el-button>
									<el-button @click="resetForm"
											   icon="el-icon-refresh">重置</el-button>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>

					<!-- 筛选折叠按钮 -->
					<div class="control-btn"
						 @click="filterShow = !filterShow">
						<span v-if="filterShow">
							点击收起
							<svg-icon icon-class="pack-up"
									  class="c-icon ml5"></svg-icon>
						</span>
						<span v-else>筛选
							<svg-icon icon-class="pack-down"
									  class="c-icon ml5"></svg-icon>
						</span>
					</div>
				</div>

				<!-- 具体内容 -->
				<div class="filter-content primary-layout">
					<div class="primary-header">
						<div class="left-text">
							<el-tooltip effect="light"
										content="项目总投资：指在项目建设期内预计或实际投入的总费用（项目管理-项目费用处填报）。"
										placement="bottom-start">
								<svg-icon icon-class="wenhao"
										  class="custom-svg"></svg-icon>
							</el-tooltip>
							合计项目: {{ tableObj.sumTotal }} 条
						</div>

						<div class="btnGroups">
							<el-button size="small"
									   class="btn-success"
									   v-if="roleBtns.includes('add_project')"
									   @click.native="handleTool('add')">新建工程项目</el-button>
							<el-button size="small"
									   class="btn-blue"
									   @click.native="showTagsDialog('add')">添加标签</el-button>
							<el-button icon="el-icon-menu"
									   type="primary"
									   size="small"
									   @click="doFilter">列过滤</el-button>
							<!-- <el-button size="small"
									   @click="exportExcel">导出Excel</el-button> -->
						</div>
					</div>
					<!-- 底部表格 -->
					<div class="primary-content"
						 v-loading="tableObj.loading">
						<CustomTableVxe v-if="tableObj.tableShow"
										ref="projectTable"
										:requestConfigUrl="CustomTableVxeData.requestConfigUrl"
										:requestDataUrl="CustomTableVxeData.requestDataUrl"
										:btnEvent="CustomTableVxeData.btnEvent"
										:config="CustomTableVxeData.table.config"
										:data="CustomTableVxeData.table.data"
										:page="CustomTableVxeData.table.page"
										@page-change="pageListen"
										@current-change="onRowClick"
										:class="{ 'xTable-tags': !topStyle }">
							<template slot="项目名称"
									  slot-scope="scope">
								<p @click="handleTool('view', scope.row)">
									<TextTooltip :refName="'projectName' + scope.row.id"
												 :content="scope.row.sname"
												 class="blue-text"></TextTooltip>
								</p>
								<el-tooltip :content="`标签：${scope.row.tags}`"
											placement="right"
											effect="light"
											v-if="scope.row.tags && scope.row.tags !== ''">
									<div slot="content"
										 class="label-tooltip">
										<el-tag class="mr10 mb10"
												size="mini"
												v-for="(item, index) in toArray(
                                                scope.row.tags
                                            )"
												:key="index">{{ item }}</el-tag>
									</div>
									<svg-icon icon-class="biaoqian"></svg-icon>
								</el-tooltip>
							</template>
							<template slot="标段是否报审"
									  slot-scope="scope">
								<div class="text-color">
									{{ statusText(scope.row.packAudit) }}
								</div>
							</template>
							<template slot="建设单位"
									  slot-scope="scope">
								<el-tooltip effect="dark"
											:content="scope.row.unitName"
											placement="top">
									<span class="vxe-cell--label">{{ scope.row.shortName }}</span>
								</el-tooltip>
							</template>
							<template slot="施工单位"
									  slot-scope="scope">
								<el-tooltip effect="dark"
											:content="scope.row.constructionUnitName"
											:disabled="scope.row.constructionUnitName == ''"
											placement="top">
									<span class="vxe-cell--label">{{ scope.row.constructionUnitShortName }}</span>
								</el-tooltip>
							</template>
							<!-- 置顶 -->
							<template slot="置顶"
									  slot-scope="scope">
								<svg-icon icon-class="zhiding"
										  class="zd-class"
										  v-if="!scope.row.sort"
										  @click="handleMove('top', scope.row)"></svg-icon>
								<el-dropdown @command="handleMove($event, scope.row)"
											 size="small"
											 placement="bottom-end"
											 v-if="scope.row.sort"
											 class="el-drop-reset">
									<svg-icon icon-class="yizhiding"
											  class="yzd-class"></svg-icon>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="cancel">取消置顶</el-dropdown-item>
										<el-dropdown-item command="up"
														  :disabled="scope.row.sort && scope.row.sort === 1">上移
										</el-dropdown-item>
										<el-dropdown-item command="down"
														  :disabled="scope.row.sort === tableObj.maxSort">下移
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</CustomTableVxe>
					</div>
				</div>
			</div>
		</el-tab-pane>
		<el-tab-pane label="财务项目"
					 name="finance"
					 disabled></el-tab-pane>

		<!-- 弹窗管理 -->
		<el-dialog :visible.sync="tagsDialog.visible"
				   class="primary-dialog"
				   :width="tagsDialog.width"
				   :title="tagsDialog.title"
				   :close-on-click-modal="false"
				   @closed="handleClosed"
				   center>
			<!-- 添加资料弹窗 -->
			<template v-if="tagsDialog.module === 'tag'">
				<!-- 当前选择标签 -->
				<el-row>
					<el-col :span="4"
							class="text-right row-label"><span>当前选择标签</span></el-col>
					<el-col :span="20"
							class="tags-container">
						<el-tag v-for="(item, index) in selectedTags"
								:key="'selectTag' + index"
								effect="dark"
								size="small"
								class="mr5"
								closable
								@close="onTagRemove(item)">{{ item.sname }}</el-tag>
					</el-col>
				</el-row>

				<!-- 新增时的 输入框 -->
				<el-row class="mt5">
					<el-col :span="20">
						<el-input v-model="newTagName"
								  placeholder="输入新的标签"
								  :maxlength="15"
								  show-word-limit></el-input>
					</el-col>
					<el-col :span="4"
							class="text-right pdl10">
						<el-button class="btn-blue row-btn"
								   @click="addNewTag">保存</el-button>
					</el-col>
				</el-row>

				<!-- 全部标签 -->
				<div class="mt5 tags-all-container">
					<el-tag v-for="(item, index) in allTags"
							:key="'allTags' + index"
							:effect="item.isChoose === 1 ? 'dark' : 'plain'"
							class="mr5"
							size="small"
							@click="onTagSelected(item)">{{ item.sname }}</el-tag>
				</div>
			</template>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button class="btn"
						   size="small"
						   @click="tagsDialog.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   class="btn btn-blue"
						   :loading="btnLoading"
						   @click="doTagsSave">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 委托审计 -->
		<el-dialog title="新增审计委托"
				   :visible.sync="entrustShow"
				   width="1100px"
				   center
				   :close-on-click-modal="false"
				   @close="entrustClose">
			<el-row>
				<el-col :span="24">
					工程项目名称：{{ selectObj.sname }}
				</el-col>
				<el-col :span="24"
						class="mt10">
					项目编号：{{ selectObj.proNo }}
				</el-col>
			</el-row>
			<el-row class="mt20">
				<el-col :span="12"
						class="flex">
					委托任务类型：
					<el-button v-for="(item, index) in projectDict.sjrwlx"
							   :key="item.value"
							   :type="taskType == item.value ? 'primary' : ''"
							   :icon="taskType == item.value ? 'el-icon-check' : ''"
							   size="small"
							   class="ml10"
							   @click="typeChange(item.value)">
						{{ item.sname }}
					</el-button>
				</el-col>
				<el-col :span="12"
						class="text-right">
					<el-input v-model="entrustSname"
							  size="small"
							  placeholder="请输入标段名称、编号进行搜索"
							  class="w350"
							  @keyup.enter.native="getSectionData">
						<template slot="append">
							<el-button @click="getSectionData">查询</el-button>
						</template>
					</el-input>
					<el-button type="success"
							   size="small"
							   class="ml10 btn-success"
							   icon="el-icon-refresh"
							   @click="refreshSection"></el-button>

				</el-col>
			</el-row>

			<vxe-table align="center"
					   border
					   class="mt15"
					   :data="sectionList"
					   highlight-current-row
					   highlight-hover-row
					   show-overflow="tooltip"
					   show-header-overflow="tooltip">
				<vxe-table-column type="seq"
								  title="序号"
								  width="60"></vxe-table-column>
				<vxe-table-column field="sname"
								  title="标段名称"
								  header-align="center"
								  align="left"></vxe-table-column>
				<vxe-table-column field="packNo"
								  title="标段编号"></vxe-table-column>
				<vxe-table-column field="packTypeName"
								  title="标段类型"
								  width="120"></vxe-table-column>
				<vxe-table-column field="duration"
								  title="合同工期"
								  width="120">
					<template #default="{ row }">
						{{ row.duration + ' 天' }}
					</template>
				</vxe-table-column>
				<vxe-table-column field="bugetValue"
								  title="标段预算金额（万元）"
								  header-align="center"
								  align="right"
								  width="170"></vxe-table-column>
				<vxe-table-column field="submitFlag"
								  :title="taskType == '1006004001' ? '跟踪审计' : '结算审计'"
								  width="120">
					<template #default="{ row, rowIndex }">
						<div :class="
                                        row.submitFlag === 1
                                            ? 'success-status'
                                            : 'error-status'
                                    ">
							{{ row.submitFlag === 1 ? "已报审" : "未报审" }}
						</div>
					</template>
				</vxe-table-column>
				<vxe-table-column width="120px"
								  title="操作">
					<template v-slot="{ row }">
						<el-button type="primary"
								   round
								   size="mini"
								   icon="el-icon-check"
								   @click="selectItem(row)">选择</el-button>
					</template>
				</vxe-table-column>
			</vxe-table>
		</el-dialog>

		<!-- 列过滤弹窗 -->
		<ColumnFilter v-if="showFilter"
					  ref="filterColumn"
					  :filterColumns="filterColumns"
					  :busType="busType"
					  memory
					  @onFilter="onFilter"></ColumnFilter>
	</el-tabs>
</template>

<script>
import { mapState } from 'vuex'
import ConfigJson from './config.json'
import * as Api from 'api/projectManage/ProjectIndex'
import * as auditAPI from 'api/audit/audit'
import * as HomeApi from '@/api/home/homeIndex'
import ColumnFilter from '@/views/Common/ColumnFilter'
import TextTooltip from '@/views/Common/TextTooltip'
import axios from 'axios'
import { getItem, setItem } from 'utils/storage'
export default {
	name: 'ProjectIndex',
	components: { ColumnFilter, TextTooltip },
	data() {
		return {
			activeTab: 'project', // 当前激活的 tab 页
			filterShow: true, // 是否展示搜索条件
			// 搜索条件对象
			searchObj: {
				size: 10,
				current: 1,
				sname: '', // 工程项目名称
				unitName: '', // 建设单位
				unitLinker: '', // 建设单位负责人
				proType: '', // 项目类型
				isNorth: undefined, // 项目地区 （1 北区 0 南区）
				assignNo: '', // 建设任务书编号
				intervalPrice: '', // 造价区间
				proYear: '', // 项目年份
				tagIds: [], // 标签搜索
			},
			tagList: [],
			// 页面参数
			tableObj: {
				sumTotal: 0, // 总合计条数
				totalNum: 0, // 当前查询总条数
				maxSort: 0, // 最大置顶值
				loading: false,
				tableShow: true,
			},
			// 列过滤对象数组
			showFilter: false,
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			// 自定义表格配置项
			CustomTableVxeData: {
				requestConfigUrl: '',
				requestDataUrl: '',
				btnEvent: [
					{
						name: '查看',
						icon: '',
						renderIcon: 'form-look',
						show: (data) => {
							return this.roleBtns.includes('view')
						},
						disabled: (data) => {
							return false
						},
						click: (data) => {
							this.handleTool('view', data)
						},
					},
					{
						name: '编辑',
						icon: '',
						renderIcon: 'form-edit',
						show: (data) => {
							return this.roleBtns.includes('edit_project')
						},
						disabled: (data) => {
							return data.isUpdateAndDeletePower !== '1'
						},
						click: (data) => {
							this.handleTool('edit', data)
						},
					},
					{
						name: '进入项目',
						icon: '',
						renderIcon: 'form-enter',
						show: (data) => {
							return this.roleBtns.includes('entrust_task')
						},
						disabled: (data) => {
							return false
						},
						click: (data) => {
							let url = this.$outUrl
							let token = this.$getSessionItem('token')
							let tenantId = this.$getSessionItem('tenantId')
							let limitId = this.$getSessionItem('limitId')
							Api.getAuditWorkPower({
								projectId: data.id,
							}).then((res) => {
								if (
									res.operationCode == 1 &&
									res.msg == 'faild'
								) {
									this.$message.warning(res.data)
									return
								}
								window.open(
									`${url}/DxAuditWork/#/main?projectId=${data.id}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
									'_blank'
								)
							})
						},
					},
					{
						name: '删除',
						icon: '',
						renderIcon: 'form-delete',
						show: (data) => {
							return this.roleBtns.includes('delete_project')
						},
						disabled: (data) => {
							return data.isUpdateAndDeletePower !== '1'
						},
						click: (data) => {
							this.handleTool('delete', data)
						},
					},
				],
				table: {
					config: {},
					page: {
						currentPage: 1,
						pageSize: 10,
						total: 1,
					},
					data: [],
				},
			},
			// 标签弹窗
			btnLoading: false,
			curRowId: '', // 当前行数据的id
			tagsDialog: {
				visible: false,
				width: '800px',
				title: '添加标签',
				type: '',
				module: 'tag',
			},
			originalTags: [], // 初始选择的标签（做最后对比）
			selectedTags: [], // 当前选择标签
			publicTags: [], // 公共标签
			personalTags: [], // 个人历史标签
			allTags: [], // 所有标签（不再显示说明）
			newTagName: '', // 输入的标签名称
			// 委托协审
			entrustShow: false, // 弹框显隐
			entrustSname: '', //搜索条件
			selectObj: {}, //选中的项目
			sectionList: [], //标段列表
			taskType: '1006004001', //委托任务类型
			topStyle: false,
			busType: '1098005',
		}
	},
	created() {
		this.CustomTableVxeData.table.config = ConfigJson.projectManagement.home
		this.getTableData()
		this.getAllTags()
	},
	methods: {
		// 获取自定义列过滤数据
		getSelfData(busType) {
			let params = { busType }
			this.tableObj.loading = true
			HomeApi.getSelfData(params)
				.then((res) => {
					if (res.data.length == 0) {
						this.tableObj.loading = false
						return
					}
					if (this.$refs.projectTable) {
						let tableShowColumn =
							this.$refs.projectTable.$children[0].getTableColumn()
						tableShowColumn.collectColumn.forEach((x) => {
							let obj = res.data.find(
								(y) => y.field == x.property
							)
							if (obj) {
								x.visible = obj.isChecked
							}
						})
						this.$refs.projectTable.refreshColumn()
					}
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 点击列过滤
		doFilter() {
			// 列过滤对象数组
			let tableShowColumn =
				this.$refs.projectTable.$children[0].getTableColumn()
			let collectColumn = tableShowColumn.collectColumn
			collectColumn.shift()
			collectColumn.pop()
			this.$set(this.filterColumns[0], 'columns', collectColumn)
			this.showFilter = true
			setTimeout(() => {
				this.$refs.filterColumn.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			if (this.$refs.projectTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.filterCheck(this.filterColumns[0])
				this.getTableData()
			}
		},

		// 初始获取表格数据
		getTableData(page) {
			if (page) {
				this.searchObj.current = 1
				this.CustomTableVxeData.table.page.currentPage = 1
			}
			let params = Object.assign({}, this.searchObj)
			if (params.tagIds.length > 0) {
				params.tagIds = params.tagIds.join(',')
			} else {
				params.tagIds = ''
			}

			let xTable = this.CustomTableVxeData.table
			this.tableObj.loading = true
			this.tableObj.tableShow = false

			// 调用接口
			Api.getProjectData(params)
				.then((res) => {
					xTable.data = res.data.page.records
					if (this.searchObj.size != -1) {
						xTable.page.total = parseInt(res.data.page.total)
						this.tableObj.sumTotal = parseInt(res.data.page.total)
					} else {
						xTable.page.total = parseInt(
							res.data.page.records.length
						)
						this.tableObj.sumTotal = parseInt(
							res.data.page.records.length
						)
					}
					this.tableObj.maxSort = res.data.maxSort
					this.tableObj.tableShow = true
					this.tableObj.loading = false
					this.getSelfData('1098005')
				})
				.catch((err) => {
					xTable.data = []
					xTable.page.total = 0
					this.tableObj.tableShow = true
					this.tableObj.loading = false
				})
		},

		// 重置表单
		resetForm() {
			this.$refs['elForm'].resetFields()

			this.getTableData(1)
		},

		// 按钮操作
		async handleTool(type, row) {
			let queryParams = {
				menu: 'project',
				type: type,
			}

			type === 'edit' || type === 'view'
				? (queryParams.projectId = row.id)
				: ''

			// 删除单独处理
			if (type === 'delete') {
				this.tableObj.loading = true
				let status = await this.$deleteConfirm('是否确认删除 ？', 1)

				if (status) {
					Api.deleteProject({ id: row.id })
						.then((res) => {
							if (res.operationCode != 1 || res.msg == 'faild') {
								this.tableObj.loading = false
								this.$message.error(res.data)
								return
							}
							this.getTableData(1)
						})
						.catch((err) => {
							this.tableObj.loading = false
						})
				} else {
					this.tableObj.loading = false
				}
				return
			}

			// 储存当前菜单
			let obj = {
				meta: this.$route.meta,
				path: this.$route.path,
				name: this.$route.name,
			}
			this.$setSessionItem('activeMenu', JSON.stringify(obj))

			// 跳转路由
			let path = type !== 'view' ? '/projectInfo' : '/projectInfoLook'
			this.$router.push({
				path: path,
				query: queryParams,
			})
		},

		// 判断报审状态文字
		statusText(status) {
			let text = ''

			switch (status) {
				case 0:
					text = '未报审'
					break
				case 1:
					text = '部分报审'
					break
				case 2:
					text = '全部报审'
					break
				default:
					text = ''
			}

			return text
		},

		// 分页监听
		pageListen(obj) {
			this.searchObj.current = obj.currentPage
			this.searchObj.size = obj.pageSize
			this.getTableData()
		},

		// 任务类型切换
		typeChange(data) {
			this.taskType = data
			this.getSectionData()
		},

		// --------------标签相关
		// 行点击事件
		onRowClick(obj) {
			this.curRowId = obj.row.id
		},

		// 展示标签
		toArray(str) {
			let arr = str ? str.split(',').filter((x) => x !== '') : []
			return arr
		},

		// 展示标签弹窗
		showTagsDialog(type) {
			if (this.curRowId === '') {
				this.$message.warning('请先选择要添加标签的项目！')
				return
			}

			this.tagsDialog.visible = true
			this.tagsDialog.type = type
			switch (type) {
				case 'add':
					// 新增
					let params = {
						objectId: this.curRowId,
						applys: '1001025003001',
						busUnit: '1001025003',
						createUserid: this.userInfo.id,
					}
					Api.getObjectTags(params)
						.then((res) => {
							// 已选择标签
							this.originalTags = JSON.parse(
								JSON.stringify(res.data.privateExsitTags)
							)
							this.selectedTags = res.data.privateExsitTags

							// // 公共标签
							// this.publicTags = res.data.platTags;

							// // 个人历史标签
							// this.personalTags = res.data.privateTags;

							// 所有标签集合
							this.allTags = [
								...res.data.platTags,
								...res.data.privateTags,
							]
						})
						.catch((err) => {})
					break
				case 'view':
					break
			}
		},

		// 保存输入的标签
		addNewTag() {
			// 去除空格
			let value = this.newTagName.replace(/\s+/, '')
			if (value && value !== '') {
				// 再判断标签 是否已存在
				let _item = this.allTags.find((x) => x.sname === value)

				if (_item) {
					switch (_item.isChoose) {
						case 1:
							this.$message.info('该标签已选择！')
							break
						default:
							_item.isChoose = 1
							this.selectedTags.push(_item)
					}
				} else {
					let params = {
						id: '',
						tagId: '',
						sname: value,
						type: '0',
						isChoose: 1,
					}
					this.selectedTags.push(params)
				}

				this.newTagName = ''
			} else {
				this.$message.warning('请输入要保存的标签！')
			}
		},

		// 标签选择
		onTagSelected(item) {
			// console.log(item)
			// 选中状态
			item.isChoose = item.isChoose === 1 ? 0 : 1

			// 选中标签数组
			if (item.isChoose === 1) {
				this.selectedTags.push(item)
			} else {
				let index = this.selectedTags.findIndex(
					(x) => x.tagId === item.tagId
				)

				if (index > -1) {
					this.selectedTags.splice(index, 1)
				}
			}
		},

		// 选中标签删除
		onTagRemove(item) {
			// 如果不是 新增的标签
			if (item.tagId !== '') {
				let _index = this.allTags.findIndex(
					(x) => x.tagId === item.tagId
				)
				if (_index > -1) {
					this.allTags[_index].isChoose = 0
				}
			}

			// 选中数组移除
			this.selectedTags.splice(this.selectedTags.indexOf(item), 1)
		},

		// 标签弹窗保存
		doTagsSave() {
			this.btnLoading = true

			let params = {
				objectId: this.curRowId,
				objectName: this.curRowName,
				applys: '1001025003001',
				busUnit: '1001025003',
				createUserid: this.userInfo.id,
				createUser: this.userInfo.sname,
				addTags: this.selectedTags,
				deleteTags: [],
			}

			// 新增、删除标签数组处理
			this.originalTags.map((x) => {
				let _item = this.selectedTags.find((y) => y.id === x.id)
				if (!_item) {
					params.deleteTags.push(x)
				}
			})
			params.addTags = this.selectedTags.filter(
				(x) => !x.id || x.id === ''
			)

			if (params.addTags.length === 0 && params.deleteTags.length === 0) {
				this.$message.warning('请操作后保存！')
				setTimeout(() => {
					this.btnLoading = false
				}, 2000)
				return
			}

			// 执行保存接口
			Api.saveObjectTags(params)
				.then((res) => {
					setTimeout(() => {
						this.btnLoading = false
						this.handleClosed(true)
					}, 2000)
				})
				.catch((err) => {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
		},

		// 弹窗关闭
		handleClosed(needRefresh) {
			this.originalTags = []
			this.selectedTags = []

			this.tagsDialog.visible = false
			this.tagsDialog.type = ''

			// 刷新
			if (needRefresh) {
				this.getTableData()
				this.getAllTags()
			}
		},

		// 委托审计
		addNewCommission(data) {
			this.entrustShow = true
			this.selectObj = data
			this.getSectionData()
		},

		// 根据项目ID 回显标段数据
		getSectionData() {
			Api.selectEntrustPackage({
				projectId: this.selectObj.id,
				packName: this.entrustSname,
				auditType: this.taskType,
			})
				.then((res) => {
					this.sectionList = res.data
				})
				.catch((err) => {
					this.sectionList = []
				})
		},

		// 重置
		refreshSection() {
			this.entrustSname = ''
			this.getSectionData()
		},

		// 委托审计弹窗关闭
		entrustClose() {
			this.taskType = '1006004001'
			this.entrustSname = ''
		},

		// 选择标段
		selectItem(data) {
			// 储存当前菜单
			let obj = {
				meta: this.$route.meta,
				path: this.$route.path,
				name: this.$route.name,
			}
			data.taskType = this.taskType
			this.$setSessionItem('activeMenu', JSON.stringify(obj))
			this.$setSessionItem('projectRow', JSON.stringify(data))
			this.$router.push({
				path: '/entrust',
				query: {
					type: 'project',
				},
			})
		},

		// 获取所有标签
		getAllTags() {
			auditAPI
				.selectTagListForBox({
					applys: '1001025003001',
					busUnit: '1001025003',
				})
				.then((res) => {
					this.tagList = res.data
				})
		},

		// 导出excel
		exportExcel() {
			//获取列过滤的数据
			var fileds = this.filterColumns[0].columns
			//符合设定 序号不参与列过滤
			var arr = []
			arr.push({
				name: '序号',
				field: 'seq',
				isCheck: true,
			})
			//组装后台需要的数据格式
			fileds.forEach((f) => {
				//处理序号是否被选中
				if (f.field != undefined && f.field != 'top' && f.visible) {
					arr.push({
						name: f.title,
						field: f.field,
						isCheck: f.visible,
					})
				}
			})
			let params = Object.assign({}, this.searchObj)
			if (params.tagIds.length > 0) {
				params.tagIds = params.tagIds.join(',')
			} else {
				params.tagIds = ''
			}
			//这里是控制是否根据列过滤导出 0 不是 1 是
			params.isAllExport = '1'
			params.exportExcleHeader = arr
			// console.log('************',arr)
			axios
				.post(
					process.env.VUE_APP_BASE_URL + 'busProject/exportProject',
					params,
					{
						responseType: 'arraybuffer',
						headers: {
							tenantId: getItem('tenantId') || '',
							token: getItem('token') || '',
							limitId: getItem('limitId') || '',
						},
					}
				)
				.then((res) => {
					console.log(res.headers, '****************')
					// 获取文件名  这里是后台使用了cache-control 放文件名称  Content-Disposition  axios不接受
					const fileName = decodeURI(
						res.headers['cache-control'].split('=')[1]
					)
					const link = document.createElement('a') // 创建元素
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel',
					})
					link.style.display = 'none'
					link.href = URL.createObjectURL(blob) // 创建下载的链接
					//num++
					link.setAttribute('download', fileName) // 给下载后的文件命名
					document.body.appendChild(link)
					link.click() // 点击下载
					document.body.removeChild(link) //  下载完成移除元素
					window.URL.revokeObjectURL(link.href) // 释放掉blob对象
				})
		},

		// 表格内 置顶功能---------------------
		handleMove(val, row) {
			// loading
			this.tableObj.loading = true

			if (val === 'top' && row.sort === 1) {
				this.tableObj.loading = false
				this.$message.warning('已经是置顶第一条数据!')
				return
			}

			let params = {
				type: val, // 置顶:top，取消置顶:cancel,置顶上移:up 置顶下移： down
				id: row.id, // 项目ID
			}
			Api.handleMove(params)
				.then((res) => {
					this.tableObj.loading = false
					this.getTableData(1)
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 判断第二列是不是 置顶
		filterCheck(data) {
			let arr = data.columns.filter((x) => x.visible == true)
			if (arr) {
				this.topStyle = arr[0].field == 'top' ? true : false
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
			// 运维角色
			isMaintenance: (state) => state.isMaintenance,
		}),
		...mapState('menu', {
			roleBtnsArr: (state) => state.roleBtns,
		}),
		roleBtns() {
			return this.isMaintenance
				? ['view', 'entrust_task']
				: this.roleBtnsArr
		},
	},
}
</script>

<style scoped lang="less">
.text-color {
	color: #60adf9;
}
.custom-svg {
	font-size: 18px !important;
	color: #aaa;
	font-weight: bold;
}
.filter-box {
	padding-top: 30px;
	padding-bottom: 15px;
}
.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px;
	}

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}
.btn {
	padding: 0 50px !important;
}
.xTable-tags {
	/deep/.vxe-table--body {
		tbody > tr > td:nth-child(2) {
			.vxe-cell {
				padding-left: 25px !important;
				position: relative;
				.svg-icon {
					position: absolute;
					left: 3px;
					top: 5px;
				}
			}
		}
	}
}
.w350 {
	width: 350px;
	/deep/ .el-input__inner {
		width: 300px !important;
	}
	.el-button {
		height: 32px !important;
		padding: 9px 20px;
	}
}

// 置顶
.move-text {
	color: #2671cc;
	font-size: 12px;
	margin-right: 10px;
	cursor: pointer;
}

.disabled-text {
	color: #bbb;
	cursor: no-drop;
}

.move-icon {
	color: #2671cc;
}
.zd-class {
	position: absolute;
	width: 100px;
	height: 65px;
	color: #2671cc;
	cursor: pointer;
	transform: translate(-50%, -44%);
}
.yzd-class {
	position: absolute;
	width: 100px;
	height: 80px;
	color: #72aa2c;
	cursor: pointer;
	transform: translate(-50%, 0%);
}
.el-drop-reset {
	width: 118px !important;
	height: 20px !important;
}
</style>

<style lang="less">
.vxe-table--tooltip-wrapper {
	z-index: 9999 !important;
}
</style>